import { useTranslation } from 'react-i18next';

export default function HowItWorks() {
  const { t } = useTranslation();

  const steps = [
    { number: '01', titleKey: 'how.step1.title', descKey: 'how.step1.desc' },
    { number: '02', titleKey: 'how.step2.title', descKey: 'how.step2.desc' },
    { number: '03', titleKey: 'how.step3.title', descKey: 'how.step3.desc' },
    { number: '04', titleKey: 'how.step4.title', descKey: 'how.step4.desc' },
  ];

  // Defensive check – if steps is ever undefined or empty we simply render nothing.
  if (!Array.isArray(steps) || steps.length === 0) return null;

  return (
    <section id="service" className="py-32 relative">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-5">
            {t('how.label')}
          </p>
          <h2 className="text-5xl lg:text-6xl font-light">{t('how.title')}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 relative">
          {/* Decorative dashed line – only visible on large screens */}
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-[2px]">
            <div className="w-full h-full border-t-2 border-dashed border-[#d4af37]/30"></div>
          </div>

          {steps.map((step, index) => (
            <div
              key={index}
              className="relative z-10 text-center space-y-6"
            >
              <div className="flex justify-center">
                <div className="w-20 h-20 rounded-full border-2 border-[#d4af37] flex items-center justify-center bg-[#1a1a1a]">
                  <span className="text-3xl font-serif text-[#d4af37]">
                    {step.number}
                  </span>
                </div>
              </div>

              <h3 className="text-xl font-semibold leading-tight min-h-[56px] flex items-center justify-center">
                {/* Fallback to the key itself if translation fails */}
                {t(step.titleKey) || step.titleKey}
              </h3>

              <p className="text-[#b8b8b8] leading-relaxed text-sm">
                {t(step.descKey) || step.descKey}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
